import React, { useState, useEffect, useRef } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import "react-circular-progressbar/dist/styles.css";
import apiService from '../../../services/apiService'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import CustomToast from '../../Toast';
import Loader from '../../layouts/loader';
import Modal from 'react-modal';
import { useDropzone } from 'react-dropzone';
import '../inviteToCourse/inviteToCourse.css';

const ManageUser = () => {
    const [courseLicenseList, setCourseLicenseList] = useState([]);
    const [selectedCourse, setSelectedCourses] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState()
    const [licenseInfo, setLicenseInfo] = useState(null)
    const [courseList, setCourseList] = useState([])
    const [orgDataInfo, setOrgData] = useState({})
    const [courseData, setCourseData] = useState([])
    const [loader, setLoader] = useState(false);
    const [totalCount, setTotalCount] = useState(1)
    const [sortOrder, setSortOrder] = useState('asc');
    const [selectedOption, setSelectedOption] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedFileName, setSelectedFileName] = useState('');
    const inputRef = useRef(null);
    const [count, setCount] = useState('')
    const [isCsvModalOpen, setIsCsvModalOpen] = useState(false);
    const [csvFile, setCsvFile] = useState()
    const [options, setOptions] = useState([]); 
    const [selectedEntity, setSelectedEntity] = useState(''); 
    const [allCourseLicenseList, setAllCourseLicenseList] = useState([]); 
    // Separate refs for each dropdown to avoid conflicts
    const entitySelectRef = useRef(null);
    const statusSelectRef = useRef(null);

    const openModal = () => {
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        clearTheForm();
    }

    const openCsvModal = () => {
        setIsCsvModalOpen(true);
    };

    const closeCsvModal = () => {
        setIsCsvModalOpen(false);
        window.location.reload(true);
    };

    const handleDropdownChange = (e) => {
        setSelectedOption(e.target.value);
        // openBulkDeactivateModal();
        console.log('SelectedOption', selectedOption);
    }

    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        setFile(file);
        setSelectedFileName(file.name);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: ['.csv'],
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!file) {
                CustomToast.info('Please upload a file.');
                return;
            }
            const fileType = file.type;
            if (fileType !== 'text/csv') {
                CustomToast.info('Please upload a CSV file.');
                return;
            }
            setLoader(true)
            const formData = new FormData();
            formData.append('image', file);
            formData.append('org_id', localStorage.getItem('ORGID'));
            formData.append('org_course_id', selectedCourse?.value);
            formData.append('type', selectedOption);
            const token = apiService.getAuthToken()
            const result = await apiService.put('bulk_revoke_and_activate', formData, token);
            if (result && result.status === "success") {
                if (result?.data?.file) {
                    setSelectedValue(null);
                    setLoader(false)
                    closeModal()
                    setCount(result?.data?.count || 0)
                    setCsvFile(result?.data?.file)
                    openCsvModal();
                } else {
                    CustomToast.success(`Bulk ${selectedOption == "revoke" ? 'Revoke' : 'Deactivate'} completed successfully`)
                    setSelectedValue(null);
                    setLoader(false)
                    closeModal()
                    setTimeout(() => {
                        window.location.reload(true);
                    }, 1000);
                }
            } else {
                setLoader(false)
                closeModal()
            }
        } catch (error) {
            setLoader(false)
            closeModal()
            if (error && error.message && error.message.includes("CSV file is empty or invalid")) {
                CustomToast.info('No data found in CSV')
            }
        }
    };

    const clearTheForm = () => {
        setFile(null);
        setSelectedValue(null);
        setSelectedFileName(null)
    };

    const percentage = 0;
    const navigate = useNavigate();

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        setSelectedOption('');
        let userDetail = sessionStorage.getItem("userDetail")
        if (userDetail) {
            userDetail = JSON.parse(userDetail)
            setUserData(userDetail)
        }
        let orgData = localStorage.getItem("orgData")
        if (orgData) {
            orgData = JSON.parse(orgData)
            setOrgData(orgData)
        }
        setLoader(true);
        getOrgCourseList(orgData)
        // fetchLicenseByOrgId(orgData)
        // fetchCourseLicenses(orgData);
        fetchData(orgData);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [currentPage]);

    // select default value
    useEffect(() => {
        setSelectedOption('');
        if (courseList.length > 0) {
            // Set the initial value to the first course in the list
            setSelectedCourses({
                value: courseList[0].org_course_id,
                label: courseList[0].name || courseList[0].course_title,
                course_id: courseList[0].course_id
            });
            const create_obj = {
                org_course_id: courseList[0].org_course_id,
                course_id: courseList[0].course_id,
                course_title: courseList[0].name || courseList[0].course_title
            }
            localStorage.setItem("selectedCourse", JSON.stringify([create_obj]))
            localStorage.setItem('selectedCourseObj', JSON.stringify(create_obj))
            const filterCourse = courseList.map((ele => {
                const obj = {
                    org_course_id: ele.org_course_id,
                    course_id: ele.course_id,
                    course_title: ele.name || ele.course_title
                }
                return obj
            })).filter((obj => obj != undefined && obj != null))
            localStorage.setItem('inviteCourseList', JSON.stringify(filterCourse));
            fetchCourseLicenses(null, courseList[0].org_course_id);
        }
    }, [courseList]);

    // get coursedetails org_id
    // get license info against org_id
    const handleCourseSelect = (selectedOptions) => {
        setSelectedOption('');
        setSelectedEntity(''); // Reset entity filter when course changes
        setOptions([]); // Clear entity options when course changes
        
        const create_obj = {
            org_course_id: selectedOptions.value,
            course_id: selectedOptions.course_id,
            course_title: selectedOptions.label
        }
        localStorage.setItem("selectedCourse", JSON.stringify([create_obj]))
        localStorage.setItem('selectedCourseObj', JSON.stringify(create_obj))
        fetchLicenseByOrgId(orgDataInfo, selectedOptions.value)
        setCourseLicenseList([])
        // Clear allCourseLicenseList before fetching new course data
        setAllCourseLicenseList([])
        fetchCourseLicenses(orgDataInfo, selectedOptions.value, '')
        setSelectedCourses(selectedOptions);
    };

    const handleSelectChange = (event) => {
        const statusValue = event.target.value;
        setSelectedOption(statusValue);
        
        // Ensure we use the currently selected course for status filtering
        if (selectedCourse && selectedCourse.value) {
            fetchCourseLicenses(orgDataInfo, selectedCourse.value, statusValue);
        }
    };

    const fetchLicenseByOrgId = async (orgData, org_course_id) => {
        setLoader(true);
        const token = apiService.getAuthToken()
        // const org_id = orgData?.org_id || localStorage.getItem('ORGID')
        // org_course_id = org_course_id ? org_course_id : "ba94356b-6c06-4996-8bad-a51b80e1349e"
        const org_id = localStorage.getItem('ORGID') //orgData?.org_id
        // const preSelectedObj = JSON.parse(localStorage.getItem('preSelectedCourseObj'))
        // org_course_id = org_course_id

        apiService.get(`get_license_status/${org_id || ''}?org_course_id=${org_course_id}`, token).then(
            (response) => {
                setLicenseInfo(response.data);
                console.log("LicenseInfo", licenseInfo)
                setLoader(false);
            },
            (error) => {
                console.error("Error fetching data", error);
                // CustomToast.error('Error while fetching license history')
                setLoader(false);
            }
        );
    };

    const fetchCourseLicenses = (orgData, org_course_id, status) => {
        console.log(`Fetching course licenses for course: ${org_course_id}, status: ${status || 'all'}`);
        setLoading(true);
        setLoader(true);
        const token = apiService.getAuthToken()
        const org_id = localStorage.getItem('ORGID')
        apiService.get(`get_user_course_list_by_org_id/${org_id}?pageSize=10&page=${currentPage}&org_course_id=${org_course_id}&status=${status || ''}`, token).then(
            // (response) => {
            //     setCourseLicenseList((prevData) => {
            //         const uniqueOrgs = response?.data.filter(
            //           (org) => !prevData.some((prevOrg) => prevOrg.name === org.name)
            //         ) || [];
            //         return [...prevData, ...uniqueOrgs];
            //       });
            // setLoading(false);
            // setLoader(false);
            // },
            // (error) => {
            // setLoading(false);
            // console.error("Error fetching data", error);
            // setLoader(false);
            // CustomToast.error('Error while fetching user course invitation')
            // }

            (response) => {
                console.log(`Received ${response.data.length} records for course: ${org_course_id}`);
                // Always update allCourseLicenseList with the current course data
                setAllCourseLicenseList(response.data);
                
                if (status !== selectedOption) {
                    setCourseLicenseList(response.data);
                } else {
                    setCourseLicenseList((prevData) => {
                        const uniqueOrgs = response?.data.filter(
                            (org) => !prevData.some((prevOrg) => prevOrg.name === org.name)
                        ) || [];
                        return [...prevData, ...uniqueOrgs];
                    });
                }
                setLoading(false);
                setLoader(false);
            },
            (error) => {
                setLoading(false);
                setLoader(false);
                console.error("Error fetching data", error);
            }
        );
    };

    function handleEditProfileClick(element) {
        // console.log(element)
        navigate('/manage_user/edit_profile', { state: { userData: element } });
        // localStorage.setItem('preSelectedCourseObj', localStorage.getItem('selectedCourseObj'))
    }

    const handleScroll = () => {
        const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || window.innerHeight;
        const scrollTrigger = 0.9;

        if (scrollTop + clientHeight >= scrollHeight * scrollTrigger && !loading && totalCount > currentPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    function onSearch(e) {
        const value = e.target.value;

        if (value) {
            const filteredOptions = courseLicenseList?.filter(option =>
                option?.name?.toLowerCase().includes(value.toLowerCase()) ||
                option?.email?.toLowerCase().includes(value.toLowerCase()) ||
                option?.mobile?.toLowerCase().includes(value.toLowerCase())
            );
            setCourseLicenseList(filteredOptions);
        } else {
            setCourseLicenseList([])
            fetchCourseLicenses(orgDataInfo, selectedCourse.value, '')
        }

    }

    const handleSort = () => {
        // Toggle the sorting order between 'asc' and 'desc'
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);

        // Sort the courseLicenseList based on the name and sorting order
        setCourseLicenseList((prevData) => {
            return [...prevData].sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();

                if (newSortOrder === 'asc') {
                    return nameA.localeCompare(nameB);
                } else {
                    return nameB.localeCompare(nameA);
                }
            });
        });
    };


    const getOrgCourseList = (orgData) => {
        const token = apiService.getAuthToken()
        apiService.get(`get_org_course_list/${orgData?.org_id || localStorage.getItem('ORGID')}`, token).then(
            (response) => {
                if (response.status == 'success') {
                    const create_obj = {
                        org_course_id: response?.data[0].org_course_id,
                        course_id: response?.data[0].course_id,
                        course_title: response?.data[0].name || response?.data[0].course_title
                    }
                    localStorage.setItem("selectedCourse", JSON.stringify([create_obj]))
                    localStorage.setItem('selectedCourseObj', JSON.stringify(create_obj))
                    fetchLicenseByOrgId({ org_id: localStorage.getItem('ORGID') }, response.data[0].org_course_id)
                    setCourseList(response.data)
                }
                setLoader(false);
            },
            (error) => {
                console.error("Error fetching data", error);
                setLoader(false);
            }
        );
    }

    const assignedLicenseReq = () => {
        const bodyData = {
            org_course_id: selectedCourse?.value,
            user_id: userData?.uid,
            org_id: userData?.org_id,
            no_license: "100"
        }

        const token = apiService.getAuthToken()
        apiService.postV1(`license-request`, bodyData, token).then(
            (response) => {
                if (response.status == 'success') {
                    CustomToast.success('Request has been sent to Inclusional.')
                    navigate('/manage_user')
                }
            },
            (error) => {
                console.error("Error fetching data", error);
                setLoader(false);
                // CustomToast.error('Error while requesting  license')
            }
        );
    }

    const fetchData = async (orgData) => {
        try {
            const token = apiService.getAuthToken()
            const result = await apiService.getv1(`get-license-info?orgId=${orgData?.org_id || localStorage.getItem('ORGID')}`, token);
            if (result && result.status === "success") {
                setCourseData(result.data);
            }
        } catch (error) {
            //   setError('Error fetching user data');
            console.error(error);
        }
    };

    const inviteUser = () => {
        if (courseData && courseData.length > 0) {
            // localStorage.setItem("selectedCourse", JSON.stringify(courseData[0].course_status))
            // localStorage.setItem('selectedCourseObj', JSON.stringify(courseData[0].course_status[0]));
            localStorage.setItem("ORGID", courseData[0].org_id)
            const orgData = {
                org_id: courseData[0].org_id,
                org_name: courseData[0].org_name
            }
            localStorage.setItem("orgData", JSON.stringify(orgData))
            navigate("/course_invite")
        } else {
            navigate("/course_invite")
        }
    }

     // Extract unique entities from the manage user list
     const extractEntitiesFromUserList = (userList) => {
        if (!userList || userList.length === 0) return [];
        
        const uniqueEntities = [...new Set(
            userList
                .map(user => user?.org_entity)
                .filter(entity => entity && entity !== "NA" && entity !== "null" && entity !== null)
        )];
        
        return uniqueEntities.map(entity => ({ org_entity: entity }));
     };

     // Check if any user in the list has valid entity data
     const hasEntityData = (userList) => {
        if (!userList || userList.length === 0) return false;
        
        return userList.some(user => 
            user?.org_entity && 
            user.org_entity !== "NA" && 
            user.org_entity !== "null" && 
            user.org_entity !== null
        );
     }; 
 
    const handleEntityChange = (event) => { 
        const entityValue = event.target.value;
        console.log(`Entity changed to: "${entityValue}", Selected Course:`, selectedCourse);
        setSelectedEntity(entityValue);
        
        // If entity is cleared, just use the existing data
        if (!entityValue) {
            setCourseLicenseList(allCourseLicenseList);
            return;
        }
        
        // Apply entity filter to the current course data
        if (allCourseLicenseList.length > 0) {
            const filteredData = filterDataByEntity(allCourseLicenseList, entityValue);
            setCourseLicenseList(filteredData);
        } else {
            // If no data available, refetch for the currently selected course
            if (selectedCourse && selectedCourse.value) {
                console.log(`No data available, refetching for course: ${selectedCourse.value}`);
                fetchCourseLicenses(orgDataInfo, selectedCourse.value, selectedOption);
            }
        }
    }; 
 
    const filterDataByEntity = (data, entity) => { 
        if (!entity || entity === '') { 
            return data; 
        } 
        if (!Array.isArray(data)) {
            console.warn('filterDataByEntity: data is not an array', data);
            return [];
        }
        const filtered = data.filter(item => item?.org_entity === entity);
        console.log(`Filtering by entity "${entity}": ${data.length} items -> ${filtered.length} items`);
        return filtered;
    }; 

    // Extract entities from user list and filter data when selectedEntity or allCourseLicenseList changes
    useEffect(() => { 
        if (allCourseLicenseList.length > 0) {
            // Extract entities from the current user list
            const entitiesFromList = extractEntitiesFromUserList(allCourseLicenseList);
            setOptions(entitiesFromList);

            // Apply entity filter to the current course data
            if (selectedEntity) { 
                const filteredData = filterDataByEntity(allCourseLicenseList, selectedEntity); 
                setCourseLicenseList(filteredData); 
            } else { 
                // If no entity is selected, show all data for the current course
                setCourseLicenseList(allCourseLicenseList);
            } 
        } else {
            // Clear entity options if no data
            setOptions([]);
        }
    }, [selectedEntity, allCourseLicenseList]); 

    return (
        <div className='page__main'>
            <div className="dashboard" style={{ minHeight: '100vh' }}>
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div>
                        <h4 className='fw-bold'>Manage Users</h4>
                        <p className='font-16 px-0'>Assign courses, update user access, and view training progress in just a few clicks.</p>
                    </div>
                    <div className='licences_btn'>
                        <button className='btn btn-md btn-primary text-white licences_btn d-flex justify-content-center align-items-center px-1' onClick={() => inviteUser()}>
                            <img src="/images/add-licenses.svg" className="me-1" width={30} height={30} />Invite New User</button>
                    </div>
                </div>
                <div className='container-fluid bg-white border-radius-20 p-4'>
                    {loader ? <Loader />
                        :
                        <div className='row d-flex align-items-center justify-content-between manage-user fw-bold mb-4'>
                            <div className="dropdown safe-workspace w-25 mb-4">
                                <label htmlFor="orgSizeSelect" className='font-16 fw-bold mb-3'>Select Course</label>
                                <Select
                                    id="orgSizeSelect"
                                    name="selectedOrgSize"
                                    placeholder="Select"
                                    value={selectedCourse}
                                    options={courseList.map((option) => ({
                                        value: option.org_course_id,
                                        label: option.name || option.course_title,
                                        course_id: option.course_id
                                    }))}
                                    onChange={handleCourseSelect}>
                                </Select>
                            </div>

                            <div className='row mb-4 mx-0 px-0'>
                                <div className='col-3'>
                                    <div className='bg_green rounded-3 p-3'>
                                        <h2 className='text-white fw-bold fs-1'>{licenseInfo?.used || 0}</h2>
                                        <p className='font-20 text-white mb-0'>
                                            <span className='me-2'><img src="/images/licences.svg" width={24} /></span>
                                            Licences Used
                                        </p>
                                    </div>
                                </div>

                                <div className='col-3 '>
                                    <div className='bg_yellow rounded-3 p-3'>
                                        <h2 className='text-white fw-bold fs-1'>{isNaN(Number(licenseInfo?.assigned) - Number(licenseInfo?.used)) ? 0 : Number(licenseInfo?.assigned) - Number(licenseInfo?.used)}</h2>
                                        <p className='font-20 text-white mb-0'>
                                            <span className='me-2'><img src="/images/licences-remaining.svg" width={24} /></span>
                                            Licences Remaining
                                        </p>
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className=' bg_red rounded-3 p-3'>
                                        <h2 className='text-white fw-bold fs-1'>{licenseInfo?.notAccepted || 0}</h2>
                                        <p className='font-20 text-white mb-0'>
                                            <span className='me-2'><img src="/images/not-accepted.svg" width={24} /></span>
                                            Not Accepted
                                        </p>
                                    </div>
                                </div>

                                <div className='col-3'>
                                    <div className='bg_primary rounded-3 p-3'>
                                        <h2 className='text-white fw-bold fs-1'>{licenseInfo?.notStarted || 0}</h2>
                                        <p className='font-20 text-white mb-0'>
                                            <span className='me-2'><img src="/images/not-started.svg" width={24} /></span>
                                            Not Started
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div className="form-group w-25 has-search">
                            <span className="form-control-feedback"><img src="/images/search.svg" alt='search' width={35} /></span>
                            <input type="text" className="form-control w-100" placeholder="Search" onChange={onSearch} />
                        </div>
                        <div className='mb-4'><button className='btn btn-md btn-secondary' onClick={openModal}><img src="/images/bulk-action.svg" alt='bulk-action' /> Bulk Action</button></div>
                    </div>
                    <div>
                        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} className="bg-white max-width-600 p-4">

                            <button type="button" className="close text-white" onClick={closeModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                            </svg></button>

                            <div className='border-0 w-75 my-4 mx-auto text-center'>

                                <h2 className='font-28 fw-bold mb-3'>Bulk Action</h2>
                                <p className='mb-3 fw-medium font-16'>Please select an action from menu below</p>

                                <div className='mx-auto w-100 position-relative'> <select className='form-select position-relative w-100 h-40 fw-bold' value={selectedOption} onChange={handleDropdownChange}>
                                    <option value="select">Select Action</option>
                                    {/* <option value="deactivate">Remind to Accept Invitation </option>
                                        <option value="revoked">Remind to Start Course</option>
                                        <option value="revoked">Remind to complete Course</option>*/}
                                    <option value="revoke">Bulk revoke licences</option>
                                    <option value="deactivated">Bulk deactivate users</option>
                                </select>
                                </div>

                                {selectedOption && (
                                    <>

                                        <div className='bulk-deactivate mt-3 mx-auto w-100 position-relative'>
                                            {loader ? <Loader /> :
                                                <form className='bulk-upload' onSubmit={handleSubmit}>

                                                    <div {...getRootProps()} className='dropzone'>
                                                        <input {...getInputProps()} />
                                                        <p className='font-18'><strong>Upload your file here</strong> </p>
                                                        <button type="button" className='file-upload-btn'>
                                                            Choose File
                                                        </button>
                                                        {selectedFileName && (
                                                            <p className='selected-file-name font-14'>{selectedFileName}</p>
                                                        )}
                                                    </div>
                                                    <button type="submit" className='btn btn-md btn-danger w-50 mt-4'>
                                                        {selectedOption == 'revoke' ? 'Revoke' : 'Deactivate'}
                                                    </button>
                                                </form>}
                                            {loader ? null : <p className='download-csv text-center mt-3 mb-0'>
                                                <a href={process.env.PUBLIC_URL + '/templates/bulkrevokeanddeactivate.csv'} className='font-weight-600'>
                                                    Download CSV or Excel template here
                                                </a>
                                            </p>}
                                        </div>

                                        {/* 
                                        <h3 className='font-18 my-4'><span className='fw-bold'>10</span> users will be notified.</h3>
                                        <button className='btn btn-md btn-primary'>Notify</button> */}

                                    </>
                                )}

                            </div>
                        </Modal>


                        <Modal
                            isOpen={isCsvModalOpen}
                            onRequestClose={closeCsvModal}
                            contentLabel="Modal"
                            className='Modal bg-white w-25 p-4'
                        >
                            <button type="button" className="close text-white" onClick={closeCsvModal}><svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                            </svg></button>

                            <div className="py-4 px-4 w-100 text-center">
                                <p className='font-16 fw-bold mt-3'>Bulk action failed for {count} users. Please download the CSV file to view detailed errors and retry.</p>
                                <div className='text-center mt-4'>
                                    <a href={csvFile} className='btn btn-primary py-2' download>
                                        Download CSV
                                    </a>
                                </div>
                            </div>
                        </Modal>

                    </div>

                    <div className='w-100' style={{ overflowX: 'auto' }}>
                        <table className="table table-responsive">
                            <thead className="thead-dark">
                                <tr>
                                    <th className='text-center'>Sr. No.</th>
                                    {hasEntityData(courseLicenseList) ? (
                                        <th>
                                            Entity
                                            <span className='ms-1 w-8 position-relative d-inline-flex align-items-center hard-white border rounded'>
                                                <select
                                                    id="entity-filter-select"
                                                    value={selectedEntity}
                                                    onChange={handleEntityChange}
                                                    className=""
                                                    ref={entitySelectRef} // reference to control the entity select
                                                    style={{ position: 'relative', zIndex: 10 }}
                                                >
                                                    <option value="">All</option>
                                                    {options.map((option, index) => (
                                                        <option key={index} value={option.org_entity}>
                                                            {option.org_entity}
                                                        </option>
                                                    ))}
                                                </select>

                                                {selectedEntity ? (
                                                    <span
                                                        className="me-2"
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            marginBottom: '1px',
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedEntity('');
                                                        }}
                                                    >
                                                        x
                                                    </span>
                                                ) : (
                                                    <span
                                                        className="me-2"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={(e) => {
                                                            // Prevent event bubbling and trigger the entity select dropdown
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            
                                                            if (entitySelectRef.current) {
                                                                try {
                                                                    if (entitySelectRef.current.showPicker) {
                                                                        entitySelectRef.current.showPicker();
                                                                    } else {
                                                                        entitySelectRef.current.focus();
                                                                        // Fallback: trigger click event on the select
                                                                        const event = new MouseEvent('mousedown', { bubbles: true });
                                                                        entitySelectRef.current.dispatchEvent(event);
                                                                    }
                                                                } catch (error) {
                                                                    console.warn('Entity dropdown trigger failed:', error);
                                                                    entitySelectRef.current.focus();
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <img src="/images/dropdown-icon.svg" alt="filter" width={16} height={16} />
                                                    </span>
                                                )}
                                            </span>
                                        </th>
                                    ) : (
                                        ''
                                    )}

                                    {/* {courseLicenseList && courseLicenseList.every((element) => element?.org_entity != "NA" || element?.org_entity != null) ? <th>Entity</th> : ''} */}
                                    <th><span onClick={handleSort} className='d-flex justify-content-between align-items-center'>Full Name <img src='/images/sort.svg' alt='sort' className='me-5' width={20} height={20} /></span></th>
                                    <th>Designation</th>
                                    <th>Email</th>
                                    <th>Phone No.</th>
                                    <th className=''>
                                        Status
                                        <span className='ms-1 w-8 position-relative d-inline-flex align-items-center bg-white rounded'>
                                            <select
                                                id="status-filter-select"
                                                ref={statusSelectRef}
                                                value={selectedOption}
                                                onChange={handleSelectChange}
                                                className=""
                                                style={{ position: 'relative', zIndex: 11 }}
                                            >
                                                <option value="">Select</option>
                                                <option value="INVITED">Invited</option>
                                                <option value="notstarted">Not Started</option>
                                                <option value="inprogress">Inprogress</option>
                                                <option value="completed">Completed</option>
                                                <option value="REVOKED">Revoked</option>
                                                <option value="deactivate">Deactivated</option>
                                            </select>

                                            {selectedOption ? (
                                                <span
                                                    className="me-2"
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '1rem',
                                                        fontWeight: 400,
                                                        marginBottom: '1px',
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedOption('');
                                                        
                                                        // Fetch complete user list for the currently selected course
                                                        if (selectedCourse && selectedCourse.value) {
                                                            // Note: Entity filter will be automatically re-applied by useEffect after data is fetched
                                                            fetchCourseLicenses(orgDataInfo, selectedCourse.value, '');
                                                        } else {
                                                            // Fallback: if no course is selected, apply entity filter to existing data
                                                            if (selectedEntity) {
                                                                const filteredData = filterDataByEntity(allCourseLicenseList, selectedEntity);
                                                                setCourseLicenseList(filteredData);
                                                            } else {
                                                                setCourseLicenseList(allCourseLicenseList);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    x
                                                </span>
                                            ) : (
                                                <span
                                                    className="me-2"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        // Prevent event bubbling and trigger the status select dropdown
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        
                                                        if (statusSelectRef.current) {
                                                            try {
                                                                // Opens the native status select dropdown (Chrome/Edge)
                                                                if (statusSelectRef.current.showPicker) {
                                                                    statusSelectRef.current.showPicker();
                                                                } else {
                                                                    // Fallback for browsers without showPicker()
                                                                    statusSelectRef.current.focus();
                                                                    // Additional fallback: trigger click event on the select
                                                                    const event = new MouseEvent('mousedown', { bubbles: true });
                                                                    statusSelectRef.current.dispatchEvent(event);
                                                                }
                                                            } catch (error) {
                                                                console.warn('Status dropdown trigger failed:', error);
                                                                statusSelectRef.current.focus();
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <img src="/images/dropdown-icon.svg" alt="filter" width={16} height={16} />
                                                </span>
                                            )}
                                        </span>
                                    </th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>

                            {loader ? <Loader />
                                : <tbody>  
                                    {courseLicenseList && courseLicenseList.length > 0 ? ( 
                                    courseLicenseList?.map((element, index) => {
                                        return <tr key={index} className={
                                            element?.merged_status === 'revoked' || element?.merged_status === 'REVOKED'
                                                ? 'revoked-row'
                                                : ''
                                        }>
                                            <td align='center'>{index + 1}</td>
                                            {hasEntityData(courseLicenseList) && <td>{element?.org_entity != "NA" && element?.org_entity != "null" && element?.org_entity != null ? element?.org_entity : ''}</td>}
                                            <td>{element?.name}</td>
                                            <td>{element?.designation != "undefined" && element?.designation != "null" && element?.designation != "Null" ? element?.designation : ''}</td>
                                            <td>{element?.email != "undefined" && element?.email != "null" && element?.email != "Null" ? element?.email : ''}</td>
                                            <td>{element?.mobile != "undefined" && element?.mobile != "null" && element?.mobile != "Null" ? element?.mobile : ''}</td>
                                            <td className="text-center">
                                                <div className='progressbar d-flex justify-content-start align-items-center'>

                                                    {element?.merged_status == 'notstarted' &&
                                                        <span className=" ms-2  notstarted-badge">Not Started</span>
                                                    }

                                                    {element?.merged_status == 'completed' &&
                                                        <span className=" ms-2 completed-badge">Completed</span>
                                                    }

                                                    {element?.merged_status == 'inprogress' &&
                                                        <span className=" ms-2  inprogress-badge">In Progress</span>
                                                    }

                                                    {element?.merged_status == 'notaccepted' &&
                                                        <span className=" ms-2 notaccepted-badge">Not Accepted</span>
                                                    }

                                                    {element?.merged_status == 'INVITED' &&
                                                        <span className=" ms-2  notaccepted-badge">Invited</span>
                                                    }

                                                    {(element?.merged_status == 'deactivate' || element?.merged_status == 'deactivated') &&
                                                        <span className=" ms-2  deactivated-badge " >Deactivated</span>
                                                    }

                                                    {element?.merged_status == 'revoked' || element?.merged_status == 'REVOKED' ? (
                                                        <span className=" ms-2 revoked-badge">Revoked</span>
                                                    ) : null
                                                    }
                                                    <div className='ms-3'>
                                                        {element?.merged_status == 'notstarted' || element?.merged_status == 'completed' || element?.merged_status == 'inprogess' || element?.merged_status == 'inprogress' ?
                                                            <CircularProgressbar
                                                                value={element.completion_percent || 0}
                                                                text={`${element.completion_percent || 0}%`}
                                                                strokeWidth={10}
                                                                className={`status-${element?.merged_status}`}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                            <td align='center'><a href="javascript:void(0)" onClick={() => handleEditProfileClick(element)} style={{ pointerEvents: element?.merged_status?.toLowerCase() === 'revoked' ? 'none' : 'auto', opacity: element?.merged_status?.toLowerCase() === 'revoked' ? 0.5 : 1 }} ><img src="/images/edit-icon.svg" alt='edit' width={20} height={20} /></a></td>
                                        </tr>
                                    })) : (
                                        <tr>
                                            <td colSpan="8" className="text-center py-4">
                                                No data found {selectedEntity ? `for "${selectedEntity}"` : ''}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>}
                            {loading && <Loader />}
                        </table>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ManageUser;